class BxfSearchFieldConstants {
    static COMPONENT_NAME = 'bxf-search-field';
    static MAX_TYPEAHEAD_DROPDOWN_WIDTH = 800;
    static STRING = {
        CONTAINER: 'bxf-search-field__container',
        CONTAINER_PARAMETRIC: 'bxf-search-field__container-parametric',
        INPUT: 'bxf-search-field__input',
        SELECT: 'bxf-search-field__select',
        SEARCH_BUTTON: 'bxf-search-field__search-button',
        SEARCH_BUTTON_FOCUS: 'bxf-search-field__search-button--focus',
        SEARCH_BUTTON_ACTIVE: 'bxf-search-field__search-button--active',
        SEARCH_BUTTON_SMALL: 'bxf-search-field__search-button-small',
        SEARCH_BUTTON_LARGE: 'bxf-search-field__search-button-large',
        SEARCH_BUTTON_DISABLED: 'bxf-search-field__search-button--disabled',
        LINK: 'bxf-search-field__link',
        PLACEHOLDER: 'Search',
        LINK_LABEL: 'Advanced Search',
        ALL_PLACEHOLDER: 'All',
        BUTTON_LABEL: 'Go', // "go button" per UX wireframe
        DEFAULT_SELECT_LABEL: 'Filter',
        TYPE_AHEAD_TABLE_FOOTER: 'bxf-type-ahead__table-footer',
        TYPE_AHEAD_INFO_ADD_BUTTON: 'bxf-type-ahead__info-add-button',
        ERROR_MESSAGE: 'bxf-search-field__message--error',
        WARNING_MESSAGE: 'bxf-search-field__message--warning',
        SUCCESS_MESSAGE: 'bxf-search-field__message--success',
        SEARCH_FIELD_INPUT_REQUIRED: 'bxf-search-field__label--required',
        SEARCH_FIELD_INPUT_REQUIRED_TOP: 'bxf-search-field__label--required-top',
        SEARCH_FIELD_INPUT_REQUIRED_SMALL: 'bxf-search-field__label--required--small',
        SEARCH_FIELD_INPUT_REQUIRED_LARGE: 'bxf-search-field__label--required--large',
        SEARCH_FIELD_INPUT_LABEL_WRAPPER: 'bxf-search-field-wrapper__label',
        SEARCH_FIELD_INPUT_LABEL: 'bxf-search-field-input__label',
        SEARCH_FIELD_INPUT_ERROR: 'bxf-search-field--error',
        SEARCH_FIELD_INPUT_WARNING: 'bxf-search-field--warning',
        SEARCH_FIELD_INPUT_SUCCESS: 'bxf-search-field--success',
        SEARCH_FIELD_BUTTON_ERROR: 'bxf-search-field-button--error',
        SEARCH_FIELD_BUTTON_WARNING: 'bxf-search-field-button--warning',
        SEARCH_FIELD_BUTTON_SUCCESS: 'bxf-search-field-button--success',
    };
}

export { BxfSearchFieldConstants as B };
